var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAerea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68.1,
    height: 68.101,
    viewBox: "0 0 68.1 68.101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_704",
    "data-name": "Trazado 704",
    d: "M197.776,276.02a2.78,2.78,0,0,0-1.122,1.88,2.951,2.951,0,0,0,2.456,3.335,13.508,13.508,0,0,1,8.612,5.215A13.763,13.763,0,0,1,210,290.968a3.067,3.067,0,0,0,1.426,1.76,2.823,2.823,0,0,0,2.213.181,2.86,2.86,0,0,0,1.85-3.638,19.767,19.767,0,0,0-5.7-9.036l.061-.03a20.71,20.71,0,0,0-3.912-2.73,19.517,19.517,0,0,0-5.882-1.971,3.42,3.42,0,0,0-.494-.036,3.054,3.054,0,0,0-1.78.552m-.243-8.369a2.78,2.78,0,0,0-.031,2.941,2.854,2.854,0,0,0,2.4,1.455,21.676,21.676,0,0,1,14.039,7.127,21.446,21.446,0,0,1,4.973,9.248l.092.395c.059.3.151.575.242.879a2.7,2.7,0,0,0,2.366,1.881,2.783,2.783,0,0,0,2.364-.789,5.066,5.066,0,0,0,.364-.424,3.212,3.212,0,0,0,.364-2.608,27.682,27.682,0,0,0-8.793-14.737c-.152-.121-.364-.273-.607-.486l-.667-.546a27.321,27.321,0,0,0-8.945-4.638,28.391,28.391,0,0,0-5.367-1.061,3.4,3.4,0,0,0-.353-.019,2.755,2.755,0,0,0-2.437,1.383m1.122-9.278a2.782,2.782,0,0,0-.818,2.183,2.893,2.893,0,0,0,2.88,2.729,29.351,29.351,0,0,1,20.892,10.673,28.531,28.531,0,0,1,5.852,11.583c.091.334.152.7.243,1.031.091.486.212.97.334,1.456A2.693,2.693,0,0,0,230.4,290a2.739,2.739,0,0,0,2.366-.758,3.048,3.048,0,0,0,.394-.486,3.311,3.311,0,0,0,.364-2.577v-.031a35.714,35.714,0,0,0-11.674-20.225c-.212-.151-.455-.363-.758-.576-.667-.516-1.485-1.183-2.366-1.759a34.716,34.716,0,0,0-9.1-4.457,36.458,36.458,0,0,0-8.672-1.608c-.068-.005-.136-.007-.2-.007a2.989,2.989,0,0,0-2.1.857",
    transform: "translate(-196.62 -257.515)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -3.004,
    y1: 34.296,
    x2: -2.988,
    y2: 34.296,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3bf7d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#3bf7d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#2deddc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#09d3f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ceff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1431",
    "data-name": "Grupo 1431",
    transform: "translate(-970.595 -5326.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_975",
    "data-name": "Grupo 975",
    transform: "translate(970.595 5326.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1732",
    "data-name": "Rect\\xE1ngulo 1732",
    fill: "none",
    stroke: "#1de9b6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.1,
    height: 68.1,
    rx: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 67.1,
    height: 67.1,
    rx: 13.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_971",
    "data-name": "Grupo 971",
    transform: "translate(986.14 5342.564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_960",
    "data-name": "Grupo 960",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1729",
    "data-name": "Rect\\xE1ngulo 1729",
    width: 51.592,
    height: 51.592,
    transform: "translate(-18.027 17.818) rotate(-45)",
    fill: "url(#linear-gradient)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAerea);
export default __webpack_public_path__ + "static/media/ic_aerea.f35124f64aaf3e466075aa588f1e409c.svg";
export { ForwardRef as ReactComponent };